module.exports = __webpack_public_path__ + "images/emoji/astonished.c3878a235b93afc09c5b.png";